(function (Drupal, Swiper) {
  Drupal.behaviors.cardsSlider = {
    attach(context) {
      once('cardsSlider', '.cards-slider', context).forEach(function (element) {
        new Swiper(element, {
          slidesPerView: 1,
          effect: "creative",
          grabCursor: true,
          watchSlidesProgress: true,
          creativeEffect: {
            perspective: true,
            limitProgress: 5,
            prev: {
              shadow: false,
              translate: [0, "-78px", 0],
              rotate: [0, 0, 0],
              scale: 0.96,
            },
            next: {
              shadow: false,
              translate: [0, "150%", 0],
              scale: 0.8,
            },
          },
          speed: 300,
          initialSlide: 3,
          observer: true,
          observeParents: true,
          direction: "vertical",
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: ".btn-next",
            prevEl: ".btn-prev",
          },
          a11y: true,
          on: {
            setTranslate: function () {
              let slides = this.slides;
              slides.forEach((slide, index) => {
                slide.style.zIndex = index + 1;
                let progress = slide.progress;
                let shadow = slide.querySelector(".slide-shadow"); // Adjust class name as necessary
                if (shadow) {
                  shadow.style.opacity = progress > 3 ? 1 : 0; // Set opacity based on progress
                }
              });
            }
          },
          breakpoints: {
            0: {
              direction: "horizontal",
              creativeEffect: {
                perspective: true,
                limitProgress: 5,
                prev: {
                  shadow: false,
                  translate: [0, "-64px", 0],
                  rotate: [0, 0, 0],
                  scale: 1,
                },
                next: {
                  shadow: false,
                  translate: [0, "150%", 0],
                  scale: 0.8,
                },
              },
            },
            768: {
              direction: "vertical",
              creativeEffect: {
                perspective: true,
                limitProgress: 5,
                prev: {
                  shadow: false,
                  translate: [0, "-78px", 0],
                  rotate: [0, 0, 0],
                  scale: 0.96,
                },
                next: {
                  shadow: false,
                  translate: [0, "150%", 0],
                  scale: 0.8,
                },
              },
            },
          },
        });
      });
    },
  };
})(Drupal, Swiper);
